<template>
    <div class="container px-3 mt-4">
        <div class="d-flex justify-content-center align-items-center signUpHeader">
            <div>
                <img border="0" :src="imgPath" width="45" height="45" alt="">
            </div>
        </div>
        <div v-if="input_area" class="signUpContents">
            <h2 class="text-center py-3 font-weight-bold">会員新規登録</h2>
            <p class="mb-4">
                必要事項をご記入のうえ、「登録内容確認へ」ボタンをクリックしてください。
            </p>
            <div v-if="submit_valid && alert_clear === false">
                <div class="alert alert-danger">
                    <div class="d-flex align-items-center mb-2">
                        <div class="icon_error"/>
                        <div class="font-weight-bold">入力内容に誤りがあります。</div>
                    </div>
                    <div class="py-1" v-if="valid_message.familyNameKana !== ''">・<span class="alert-text">{{ valid_message.familyNameKana }}</span></div>
                    <div class="py-1" v-if="valid_message.givenNameKana !== ''">・<span class="alert-text">{{ valid_message.givenNameKana }}</span></div>
                    <div class="py-1" v-if="valid_message.familyName !== ''">・<span class="alert-text">{{ valid_message.familyName }}</span></div>
                    <div class="py-1" v-if="valid_message.givenName !== ''">・<span class="alert-text">{{ valid_message.givenName }}</span></div>
                    <div class="py-1" v-if="valid_message.zipcode !== ''">・<span class="alert-text">{{ valid_message.zipcode }}</span></div>
                    <div class="py-1" v-if="valid_message.address1 !== ''">・<span class="alert-text">{{ valid_message.address1 }}</span></div>
                    <div class="py-1" v-if="valid_message.mobile_number !== ''">・<span class="alert-text">{{ valid_message.mobile_number }}</span></div>
                    <div class="py-1" v-if="valid_message.password !== ''">・<span class="alert-text">{{ valid_message.password }}</span></div>
                    <div class="py-1" v-if="valid_message.rePassword !== ''">・<span class="alert-text">{{ valid_message.rePassword }}</span></div>
                    <div class="py-1" v-if="recaptcha.setflag === false">・<span class="alert-text">画像認証にチェックを入れてください。</span></div>
                    <div class="py-1" v-if="valid_message.termsOfServices !== ''">・<span class="alert-text">{{ valid_message.termsOfServices }}</span></div>
                </div>
            </div>
            <form>
                <div class="mb-5">
                    <div class="form-group mb-3 row">
                        <label class="col-sm-3 col-form-label font-weight-bold">
                            <span class="pr-2">お名前カナ</span>
                            <span class="badge bg-danger text-white badge-required">※必須</span>
                        </label>
                        <div class="col-sm-9">
                            <div class="row">
                                <div class="col">
                                    <input
                                        id="familyNameKana"
                                        type="text"
                                        :class="{'is-invalid': valid.familyNameKana}"
                                        class="col form-control"
                                        v-model="familyNameKana"
                                        placeholder="カナ（姓）"
                                        @blur="checkInputData"
                                        @input="checkInputData"
                                    />
                                    <div
                                        class="invalid-feedback"
                                        v-if="valid.familyNameKana"
                                    >{{ valid_message.familyNameKana }}</div>
                                </div>
                                <div class="col">
                                    <input
                                        id="givenNameKana"
                                        type="text"
                                        :class="{'is-invalid': valid.givenNameKana}"
                                        class="col form-control"
                                        v-model="givenNameKana"
                                        placeholder="カナ（名）"
                                        @blur="checkInputData"
                                        @input="checkInputData"
                                    />
                                    <div
                                        class="invalid-feedback"
                                        v-if="valid.givenNameKana"
                                    >{{ valid_message.givenNameKana }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="form-group mb-3 row">
                        <label class="col-sm-3 col-form-label font-weight-bold">
                            <span class="pr-2">お名前</span>
                            <span class="badge bg-danger text-white badge-required">※必須</span>
                        </label>
                        <div class="col-sm-9">
                            <div class="row">
                                <div class="col">
                                    <input
                                        id="familyName"
                                        type="text"
                                        :class="{'is-invalid': valid.familyName}"
                                        class="col form-control"
                                        v-model="familyName"
                                        placeholder="姓"
                                        @blur="checkInputData"
                                        @input="checkInputData"
                                    />
                                    <div
                                        class="invalid-feedback"
                                        v-if="valid.familyName"
                                    >{{ valid_message.familyName }}</div>
                                </div>
                                <div class="col">
                                    <input
                                        id="givenName"
                                        type="text"
                                        :class="{'is-invalid': valid.givenName}"
                                        class="col form-control"
                                        v-model="givenName"
                                        placeholder="名"
                                        @blur="checkInputData"
                                        @input="checkInputData"
                                    />
                                    <div
                                        class="invalid-feedback"
                                        v-if="valid.givenName"
                                    >{{ valid_message.givenName }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-sm-3 col-form-label font-weight-bold">
                            <span class="pr-2">性別</span>
                            <span class="badge bg-danger text-white badge-required">※必須</span>
                        </label>
                        <div class="col-sm-9">
                            <div class="row align-items-center fullHeight">
                                <div class="col">
                                    <div class="form-check">
                                        <input
                                            class="form-check-input"
                                            type="radio"
                                            :value="0"
                                            v-model="gender"
                                            checked
                                        />
                                        <label class="form-check-label" for="gridRadios1">男性</label>
                                    </div>
                                </div>
                                <div class="col">
                                    <div class="form-check">
                                        <input
                                            class="form-check-input"
                                            type="radio"
                                            :value="1"
                                            v-model="gender"
                                        />
                                        <label class="form-check-label" for="gridRadios2">女性</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-sm-3 col-form-label font-weight-bold">
                            <span class="pr-2">生年月日</span>
                            <span class="badge bg-danger text-white badge-required">※必須</span>
                        </label>
                        <div class="col-sm-9">
                            <div class="row">
                                <div class="col-12 col-sm-4 birthDateMb1">
                                    <select class="custom-select" v-model="year" @change="get_days">
                                        <option
                                            v-for="n in year_max"
                                            :value="n + 1900"
                                            selected="1980"
                                            :key="n"
                                        >{{ n + 1900 }}年</option>
                                    </select>
                                </div>
                                <div class="col-12 col-sm-4 birthDateMb1">
                                    <select
                                        class="custom-select"
                                        v-model="month"
                                        @change="get_days"
                                    >
                                        <option v-for="n in 12" :value="n" :key="n">{{ n }}月</option>
                                    </select>
                                </div>
                                <div class="col-12 col-sm-4">
                                    <select class="custom-select" v-model="day">
                                        <option v-for="n in days_max" :value="n" :key="n">{{ n }}日</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-sm-3 col-form-label font-weight-bold">
                            <span class="pr-2">郵便番号</span>
                            <span class="badge bg-danger text-white badge-required" v-if="!nrgFlag">※必須</span>
                        </label>
                        <div class="col-sm-9">
                            <div class="row">
                                <div class="col-12 col-sm-4 birthDateMb1">
                                    <input
                                        id="zipcode"
                                        v-model="zipCode"
                                        type="text"
                                        :class="{'is-invalid': valid.zipcode}"
                                        class="col form-control"
                                        placeholder="半角数字7桁(ハイフン無し)"
                                        @blur="checkInputData"
                                        @input="checkInputData"
                                    />
                                    <div
                                        class="invalid-feedback"
                                        v-if="valid.zipcode"
                                    >{{ valid_message.zipcode }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-sm-3 col-form-label font-weight-bold">
                            <span class="pr-2">住所</span>
                            <span class="badge bg-danger text-white badge-required" v-if="!nrgFlag">※必須</span>
                        </label>
                        <div class="col-sm-9">
                            <input
                                id="address1"
                                type="text"
                                v-model="address1"
                                :class="{'is-invalid': valid.address1}"
                                class="col form-control"
                                placeholder="都道府県、市区町村　など"
                                @blur="checkInputData"
                                @input="checkInputData"
                            />
                            <div
                                class="invalid-feedback"
                                v-if="valid.address1"
                            >{{ valid_message.address1 }}</div>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-sm-3 col-form-label"></label>
                        <div class="col-sm-9">
                            <input
                                id="address2"
                                type="text"
                                v-model="address2"
                                :class="{'is-invalid': valid.address2}"
                                class="col form-control"
                                placeholder="番地、建物、号　など"
                                @blur="checkInputData"
                                @input="checkInputData"
                            />
                            <div
                                class="invalid-feedback"
                                v-if="valid.address2"
                            >{{ valid_message.address2 }}</div>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-sm-3 col-form-label font-weight-bold">
                            携帯番号
                        </label>
                        <div class="col-sm-9">
                            <input
                                id="mobile_number"
                                type="tel"
                                :class="{'is-invalid': valid.mobile_number}"
                                class="col form-control"
                                v-model="mobile_number"
                                placeholder="半角数字11桁(ハイフン無し)"
                                @blur="checkInputData"
                                @input="checkInputData"
                                :disabled="mobile_number_disabled"
                                autocomplete="new-password"
                            />
                            <div
                                class="invalid-feedback"
                                v-if="valid.mobile_number"
                            >{{ valid_message.mobile_number }}</div>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-sm-3 col-form-label font-weight-bold">メールアドレス</label>
                        <div class="col-sm-9">
                            <input
                                id="email"
                                type="email"
                                class="col form-control"
                                v-model="email"
                                placeholder="メールアドレス"
                                @blur="checkInputData"
                                @input="checkInputData"
                                disabled
                            />
                            <div
                                class="invalid-feedback"
                                v-if="valid.password"
                            >{{ valid_message.password }}</div>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-sm-3 col-form-label font-weight-bold">
                            <span class="pr-2">パスワード</span>
                            <span class="badge bg-danger text-white badge-required">※必須</span>
                        </label>
                        <div class="col-sm-9">
                            <input
                                id="password"
                                type="password"
                                :class="{'is-invalid': valid.password}"
                                class="col form-control passwordReadOnly"
                                v-model="password"
                                placeholder="半角英数字8文字以上"
                                @blur="checkInputData"
                                @input="checkInputData"
                                autocomplete="new-password"
                                @mouseover="passwordForm"
                                @mouseout="passwordForm"
                            />
                            <div
                                class="invalid-feedback"
                                v-if="valid.password"
                            >{{ valid_message.password }}</div>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-sm-3 col-form-label font-weight-bold">
                            <span class="pr-2">パスワード (確認)</span>
                            <span class="badge bg-danger text-white badge-required">※必須</span>
                        </label>
                        <div class="col-sm-9">
                            <input
                                id="rePassword"
                                type="password"
                                :class="{'is-invalid': valid.rePassword}"
                                class="col form-control passwordReadOnly"
                                v-model="rePassword"
                                placeholder="半角英数字8文字以上"
                                @blur="checkInputData"
                                @input="checkInputData"
                                autocomplete="new-password"
                                @mouseover="passwordForm"
                                @mouseout="passwordForm"
                            />
                            <div
                                class="invalid-feedback"
                                v-if="valid.rePassword"
                            >{{ valid_message.rePassword }}</div>
                        </div>
                    </div>
                </div>
                <div class="mb-5">
                    <div class="form-group row">
                        <label class="col-sm-3 col-form-label font-weight-bold">
                            <span class="pr-2">画像認証</span>
                            <span class="badge bg-danger text-white badge-required">※必須</span>
                        </label>
                        <div class="col-sm-9">
                            <vue-recaptcha
                                :sitekey="this.recaptcha_site_key"
                                ref="invisibleRecaptcha"
                                @verify="onVerify"
                                @expired="onExpired"
                            ></vue-recaptcha>
                        </div>
                    </div>
                </div>
                <div class="mb-4">
                    <div class="form-group row">
                        <label class="col-sm-3 col-form-label font-weight-bold">
                            <span class="pr-2">利用規約</span>
                            <span class="badge bg-danger text-white badge-required">※必須</span>
                        </label>
                        <div class="col-sm-9 py-2">
                            <div class="form-check">
                                <input
                                    class="form-check-input"
                                    type="checkbox"
                                    :class="{'is-invalid': valid.termsOfServices}"
                                    v-model="termsOfServices"
                                    @input="checkInputData"
                                />
                                <label class="form-check-label">利用規約に同意します</label>
                                <div
                                    class="invalid-feedback"
                                    v-if="valid.termsOfServices"
                                >{{ valid_message.termsOfServices }}</div>
                            </div>
                        </div>
                        <div class="col-sm-12">
                            <div class="ruleArea py-2"><pre>{{ rule }}</pre></div>
                        </div>
                    </div>
                </div>
                <div class="text-center mb-4">
                    <button
                        type="button"
                        class="confirmbutton col-sm-4"
                        @click="submitConfirmation"
                    >登録内容確認へ</button>
                </div>
            </form>
        </div>
        <div v-if="confirmation_area" class="signUpContents">
            <h2 class="text-center py-3">会員新規登録</h2>
            <form>
                <div class="row">
                    <div class="offset-sm-3 col-sm-9">
                        <p class="mb-4">
                            以下の内容で登録いたします。
                            <br />「登録」ボタンをクリックすると登録が完了します。
                            <br />内容を修正する場合は「修正」ボタンをクリックしてください。
                        </p>
                        <div class="mb-5">
                            <div class="form-group mb-3 row">
                                <label class="col-sm-3 col-form-label">お名前カナ</label>
                                <div
                                    class="col-sm-9"
                                >{{ put_data.family_name_kana }} {{ put_data.given_name_kana }}</div>
                            </div>
                            <div class="form-group mb-3 row">
                                <label class="col-sm-3 col-form-label">お名前</label>
                                <div
                                    class="col-sm-9"
                                >{{ put_data.family_name }} {{ put_data.given_name }}</div>
                            </div>
                            <div class="form-group mb-3 row">
                                <label class="col-sm-3 col-form-label">性別</label>
                                <div class="col-sm-9">{{ gender_label }}</div>
                            </div>
                            <div class="form-group mb-3 row">
                                <label class="col-sm-3 col-form-label">生年月日</label>
                                <div
                                    class="col-sm-9"
                                >{{ put_data.birth_date | date_format_ja('-') }}</div>
                            </div>
                            <div class="form-group mb-3 row">
                                <label class="col-sm-3 col-form-label">郵便番号</label>
                                <div class="col-sm-9">{{ zipCodeFormat(put_data.zipcode) }}</div>
                            </div>
                            <div class="form-group mb-3 row">
                                <label class="col-sm-3 col-form-label">住所</label>
                                <div class="col-sm-9">{{ addressFormat(put_data.address1) }}</div>
                                <label class="col-sm-3 col-form-label"></label>
                                <div class="col-sm-9">{{ put_data.address2 }}</div>
                            </div>
                            <div class="form-group mb-3 row">
                                <label class="col-sm-3 col-form-label">携帯番号</label>
                                <div class="col-sm-9">{{ formatSP(mobile_number_label) }}</div>
                            </div>
                            <div class="form-group mb-3 row">
                                <label class="col-sm-3 col-form-label">メールアドレス</label>
                                <div class="col-sm-9">
                                    <input
                                        type="email"
                                        disabled
                                        class="form-control-plaintext"
                                        :value="this.email"
                                    />
                                </div>
                            </div>
                            <div class="form-group mb-3 row">
                                <label class="col-sm-3 col-form-label">パスワード</label>
                                <div class="col-sm-9">
                                    <input
                                        type="password"
                                        disabled
                                        class="form-control-plaintext"
                                        :value="this.put_data.password"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="mb-4">
                    <div class="row justify-content-center">
                        <button
                            type="button"
                            class="confirmbutton col-sm-3 mx-2"
                            @click="submitSingUp"
                        >登録</button><br>
                        <button
                            type="button"
                            class="mypagebackbutton col-sm-3 mx-2"
                            @click="submitCancel"
                        >修正</button><br>
                    </div>
                </div>
            </form>
        </div>
        <div class="graywindow mt-5">
            <div v-if="error_page" class="pt-3 pb-3 row row-notMx justify-content-center text-center">
                {{ this.expiration }}
            </div>
        </div>
    </div>
</template>
<script>
import {
    REGISTER_MEMBER,
    CHECK_TMP_MEMBER,
    REGISTER_MEMBER_TMP_USING_SOCIAL
} from "../../constants/signup.js";
import { GET_TEMPLATE } from "../../constants/template_masters.js";
import VueRecaptcha from "vue-recaptcha";
import validater from "../../lib/validater";
import { createApollo } from "../../lib/apollo";
import { utilityMixin } from '../../mixins/utility';

export default {
    components: {
        validater,
        VueRecaptcha
    },
    mixins: [
        utilityMixin
    ],
    data() {
        const $t = this.$t.bind(this);
        return {
            // 利用規約のサンプル用データ
            rule: "",
            year: 1980,
            month: 1,
            day: 1,
            familyName: "",
            familyNameKana: "",
            givenName: "",
            givenNameKana: "",
            zipCode: "",
            address1: "",
            address2: "",
            password: "",
            rePassword: "",
            gender: 0,
            mobile_number_disabled: false,
            termsOfServices: null,
            input_area: true,
            confirmation_area: false,
            error_page: false,
            gender_label: "",
            mobile_number_label: "",
            email: "",
            mobile_number: "",
            urlToken: "",
            error_text: "",
            expiration: "",
            valid: {
                familyName: false,
                familyNameKana: false,
                givenName: false,
                givenNameKana: false,
                zipcode: false,
                address1: false,
                address2: false,
                mobile_number: false,
                password: false,
                rePassword: false,
                termsOfServices: false
            },
            valid_message: {
                familyName: "",
                familyNameKana: "",
                givenName: "",
                givenNameKana: "",
                zipcode: "",
                address1: "",
                address2: "",
                mobile_number: "",
                password: "",
                rePassword: "",
                termsOfServices: ""
            },
            put_data: {
                family_name: "",
                family_name_kana: "",
                given_name: "",
                given_name_kana: "",
                birth_date: "",
                zipcode: "",
                address1: "",
                address2: "",
                gender: null,
                token: "",
                mobile_number: "",
                password: "",
                password_confirmation: ""
            },
            recaptcha_site_key: "",
            recaptcha: {
                setflag: false, //reCAPTCHAに値が入ったかどうか
                response: "" //レスポンスのトークン
            },
            auth_code: "",
            submit_valid: false,
            alert_clear: false,
            // ロゴのURL
            imgPath: "/images/" + process.env.MIX_STYLE_NAME + "_logo_2.png",
            // 南幌用判定フラグ
            nrgFlag: process.env.MIX_STYLE_NAME == 'nrg' ? true: false
        };
    },
    created() {
        this.initialize();
    },
    watch: {
        // 利用規約のチェックボックス値監視
        termsOfServices: function(now) {
            if (now) {
                this.valid_message.termsOfServices = "";
                this.valid.termsOfServices = false;
            } else {
                this.valid_message.termsOfServices = this.$t(
                    "error.validation.termsOfServices"
                );
                this.valid.termsOfServices = true;
            }
            this.alertCheck();
        }
    },
    methods: {
        /** ----------------------------------------------
         * 初期表示時処理
         * ---------------------------------------------- */
        initialize: async function() {
            this.input_area = false;
            this.confirmation_area = false;
            this.error_page = false;
            this.get_days();
            // 画像認証のSITEキーを取得
            this.recaptcha_site_key = process.env.MIX_RECAPTCHA_SITE_KEY;

            this.$store.commit("loading/setIsLoading", true);

            // トークンチェック
            // codeがある場合はLINEによる仮登録処理を行う
            if (this.$route.query.code) {
                await this.checkTokenForLineRegistration();
            } else {
                await this.checkTokenForEmailRegistration();
            }

            this.$store.commit("loading/setIsLoading", false);

            // 利用規約データをDBから取得
            this.$apollo
                .query({
                    query: GET_TEMPLATE,
                    variables: {
                        template_code: "1"
                    }
                })
                .then(res => {
                    this.rule = res.data.GetTemplate.template;
                    this.rule;
                })
                .catch(error => {
                    this.error = error;
                });
        },
        /**
         * メールアドレスによる仮登録処理で得たTokenの処理
         */
        checkTokenForEmailRegistration: async function() {
            this.urlToken = this.$route.query.token;
            try {
                let res = await this.$apollo.query({
                    query: CHECK_TMP_MEMBER,
                    variables: {
                        token: this.urlToken
                    }
                });
                this.email = res.data.checkTmpMemberToken.email;
                if (res.data.checkTmpMemberToken.tmp_member_no !== 0) {
                    if (res.data.checkTmpMemberToken.given_name) {
                        this.familyName = res.data.checkTmpMemberToken.family_name;
                        this.givenName = res.data.checkTmpMemberToken.given_name;
                    }
                    if (res.data.checkTmpMemberToken.birth_date) {
                        let birthDate = res.data.checkTmpMemberToken.birth_date;
                        let birthDateArr = birthDate.split(/-/);
                        this.year = Number(birthDateArr[0]);
                        this.month = Number(birthDateArr[1]);
                        this.day = Number(birthDateArr[2]);
                    }
                    this.mobile_number = res.data.checkTmpMemberToken.mobile_number;
                    if (this.mobile_number) {
                        this.mobile_number_disabled = true;
                    }
                }
                this.input_area = true;
                this.confirmation_area = false;
                this.error_page = false;
            } catch (error) {
                if (error.graphQLErrors[0].message == "Failed Regist Tmp Member") {
                    this.expiration = this.$t("error.validation.expiration");
                } else {
                    this.expiration = this.$t("error.validation.systemError");
                }
                this.input_area = false;
                this.confirmation_area = false;
                this.error_page = true;
            }
        },
        /**
         * LINEからの登録で得たTokenの処理
         */
        checkTokenForLineRegistration: async function() {
            // LINE認証用のURLのapollo clientを作成
            let url =
                process.env.MIX_GRAPHQL_URI +
                "graphql?code=" +
                this.$route.query.code;
            const client = createApollo(url);

            try {
                let tmpData = await client.mutate({
                    mutation: REGISTER_MEMBER_TMP_USING_SOCIAL,
                    variables: {
                        queryId: localStorage.getItem("Auth.snsQueryId"),
                        queryToken: localStorage.getItem("Auth.snsQueryToken")
                    }
                });

                this.urlToken = tmpData.data.registerMemberTmpUsingSocial.token;

                let res = await this.$apollo.query({
                    query: CHECK_TMP_MEMBER,
                    variables: {
                        token: this.urlToken
                    }
                });
                this.email = res.data.checkTmpMemberToken.email;
                this.input_area = true;
                this.confirmation_area = false;
                this.error_page = false;
            } catch (error) {
                this.expiration = error.graphQLErrors[0].message;
                this.input_area = false;
                this.confirmation_area = false;
                this.error_page = true;
            }
        },
        /** ----------------------------------------------
         * 生年月日設定
         * ---------------------------------------------- */
        get_days: function() {
            this.year_max = new Date().getFullYear() - 1900;
            this.days_max = new Date(this.year, this.month, 0).getDate();
            const preDate = new Date(this.year, this.month, this.day);
            // ありえない日付になるのを防ぐ
            if (this.days_max < this.day) {
                this.day = this.days_max;
            }
        },
        /** ----------------------------------------------
         * 生年月日の0埋め処理（形式：1980-01-01）
         * @param y：年度
         * @param m：月
         * @param d：日
         * ---------------------------------------------- */
        daysJoin: function(y, m, d) {
            const year = y;
            const month = ("0" + m).slice(-2);
            const day = ("0" + d).slice(-2);
            return year + "-" + month + "-" + day;
        },

        /** ----------------------------------------------
         * バリデーションチェック
         * ---------------------------------------------- */
        checkInputData: function(event) {
            if (!event.target.value) {
                this.nullValueCheck(event.target.id);
            } else {
                this.inputValueCheck(event.target.id);
            }

            if (event.type !== 'input') {
                this.alertCheck();
            }
        },
        /** ----------------------------------------------
         * 入力時のバリデーション
         * ---------------------------------------------- */
        inputValueCheck: function(targetId) {
            if (targetId === "familyName") {
                // 氏名姓チェック
                if (
                    !validater.checkStringLengthMax(event.target.value, 50)
                ) {
                    this.valid_message.familyName = this.$t(
                        "error.validation.length.familyName"
                    );
                    this.valid.familyName = true;
                } else {
                    this.valid_message.familyName = "";
                    this.valid.familyName = false;
                }
            } else if (targetId === "givenName") {
                // 氏名名チェック
                if (
                    !validater.checkStringLengthMax(event.target.value, 50)
                ) {
                    this.valid_message.givenName = this.$t(
                        "error.validation.length.givenName"
                    );
                    this.valid.givenName = true;
                } else {
                    this.valid_message.givenName = "";
                    this.valid.givenName = false;
                }
            } else if (targetId === "familyNameKana") {
                // カタカナ姓チェック
                if (
                    !validater.checkStringLengthMax(event.target.value, 50)
                ) {
                    this.valid_message.familyNameKana = this.$t(
                        "error.validation.length.familyNameKana"
                    );
                    this.valid.familyNameKana = true;
                } else if (
                    !validater.checkZenHanKana(event.target.value)
                ) {
                    this.valid_message.familyNameKana = this.$t(
                        "error.validation.familyNameKana"
                    );
                    this.valid.familyNameKana = true;
                } else {
                    this.valid_message.familyNameKana = "";
                    this.valid.familyNameKana = false;
                }
            } else if (targetId === "givenNameKana") {
                // カタカナ名チェック
                if (
                    !validater.checkStringLengthMax(event.target.value, 50)
                ) {
                    this.valid_message.givenNameKana = this.$t(
                        "error.validation.length.givenNameKana"
                    );
                    this.valid.givenNameKana = true;
                } else if (
                    !validater.checkZenHanKana(event.target.value)
                ) {
                    this.valid_message.givenNameKana = this.$t(
                        "error.validation.givenNameKana"
                    );
                    this.valid.givenNameKana = true;
                } else {
                    this.valid_message.givenNameKana = "";
                    this.valid.givenNameKana = false;
                }
            } else if (targetId === "zipcode") {
                // 郵便番号チェック
                if (
                    !validater.checkStringLengthMax(event.target.value, 7)
                ) {
                    this.valid_message.zipcode = this.$t(
                        "error.validation.length.zipcode"
                    );
                    this.valid.zipcode = true;
                } else if (
                    !validater.checkStringLengthMin(event.target.value, 7)
                ) {
                    this.valid_message.zipcode = this.$t(
                        "error.validation.length.zipcode"
                    );
                    this.valid.zipcode = true;
                } else if (
                    !validater.checkNumber(event.target.value)
                ) {
                    this.valid_message.zipcode = this.$t(
                        "error.validation.length.zipcode"
                    );
                    this.valid.zipcode = true;
                } else {
                    this.valid_message.zipcode = "";
                    this.valid.zipcode = false;
                }
            } else if (targetId === "address1") {
                // 住所チェック
                if (
                    !validater.checkStringLengthMax(event.target.value, 50)
                ) {
                    this.valid_message.address1 = this.$t(
                        "error.validation.length.address"
                    );
                    this.valid.address1 = true;
                } else {
                    this.valid_message.address1 = "";
                    this.valid.address1 = false;
                }
            } else if (targetId === "address2") {
                // 住所チェック
                if (
                    !validater.checkStringLengthMax(event.target.value, 50)
                ) {
                    this.valid_message.address2 = this.$t(
                        "error.validation.length.address"
                    );
                    this.valid.address2 = true;
                } else {
                    this.valid_message.address2 = "";
                    this.valid.address2 = false;
                }
            } else if (targetId === "mobile_number") {
                // 携帯番号チェック
                this.valid_message.mobile_number = "";
                this.valid.mobile_number = false;
                if (!validater.checkStringLengthMax(event.target.value,11)) {
                    this.valid_message.mobile_number = this.$t("error.validation.length.mobileNumber");
                    this.valid.mobile_number = true;
                } else if (!validater.checkmobilenumber(this.mobile_number)) {
                    this.valid_message.mobile_number = this.$t("error.validation.mobileNumber");
                    this.valid.mobile_number = true;
                }
            } else if (targetId === "password") {
                // パスワードチェック
                if (!validater.checkStringType(this.password)) {
                    this.valid_message.password = this.$t(
                        "error.validation.stringtype"
                    );
                    this.valid.password = true;
                } else if (!validater.checkComplexity(this.password)) {
                    this.valid_message.password = this.$t(
                        "error.validation.complexity"
                    );
                    this.valid.password = true;
                } else if (
                    !validater.checkStringLengthMax(event.target.value, 128)
                ) {
                    this.valid_message.password = this.$t(
                        "error.validation.length.passwordMax"
                    );
                    this.valid.password = true;
                } else if (
                    !validater.checkStringLengthMin(event.target.value, 8)
                ) {
                    this.valid_message.password = this.$t(
                        "error.validation.length.passwordMin"
                    );
                    this.valid.password = true;
                } else {
                    // パスワード一致チェック
                    if (this.password && this.rePassword) {
                        if (this.password !== this.rePassword) {
                            this.valid_message.password = this.$t(
                                "error.validation.unmatchPassword"
                            );
                            this.valid.password = true;
                        } else {
                            this.valid_message.password = "";
                            this.valid.password = false;
                            this.valid_message.rePassword = "";
                            this.valid.rePassword = false;
                        }
                    } else {
                        this.valid_message.password = "";
                        this.valid.password = false;
                    }
                }
            } else if (targetId === "rePassword") {
                // パスワード（確認）チェック
                if (!validater.checkStringType(this.rePassword)) {
                    this.valid_message.rePassword = this.$t(
                        "error.validation.stringtype"
                    );
                    this.valid.rePassword = true;
                } else if (!validater.checkComplexity(this.rePassword)) {
                    this.valid_message.rePassword = this.$t(
                        "error.validation.complexity"
                    );
                    this.valid.rePassword = true;
                } else if (
                    !validater.checkStringLengthMax(event.target.value, 128)
                ) {
                    this.valid_message.rePassword = this.$t(
                        "error.validation.length.rePasswordMax"
                    );
                    this.valid.rePassword = true;
                } else if (
                    !validater.checkStringLengthMin(event.target.value, 8)
                ) {
                    this.valid_message.rePassword = this.$t(
                        "error.validation.length.rePasswordMin"
                    );
                    this.valid.rePassword = true;
                } else {
                    // パスワード一致チェック
                    if (this.password && this.rePassword) {
                        if (this.password !== this.rePassword) {
                            this.valid_message.rePassword = this.$t(
                                "error.validation.unmatchPassword"
                            );
                            this.valid.rePassword = true;
                        } else {
                            this.valid_message.password = "";
                            this.valid.password = false;
                            this.valid_message.rePassword = "";
                            this.valid.rePassword = false;
                        }
                    } else {
                        this.valid_message.rePassword = "";
                        this.valid.rePassword = false;
                    }
                }
            }
        },
        /** ----------------------------------------------
         * 未入力時のバリデーションエラー設定
         * ---------------------------------------------- */
        nullValueCheck: function(targetId) {
            if (targetId === "familyName") {
                this.valid_message.familyName = this.$t("error.validation.required.familyName");
                this.valid.familyName = true;
            } else if (targetId === "givenName") {
                this.valid_message.givenName = this.$t("error.validation.required.givenName");
                this.valid.givenName = true;
            } else if (targetId === "familyNameKana") {
                this.valid_message.familyNameKana = this.$t("error.validation.required.familyNameKana");
                this.valid.familyNameKana = true;
            } else if (targetId === "givenNameKana") {
                this.valid_message.givenNameKana = this.$t("error.validation.required.givenNameKana");
                this.valid.givenNameKana = true;
            } else if (targetId === "zipcode") {
                if (this.nrgFlag) {
                    this.valid_message.zipcode = "";
                    this.valid.zipcode = false;
                } else {
                    this.valid_message.zipcode = this.$t("error.validation.required.zipcode");
                    this.valid.zipcode = true;
                }
            } else if (targetId === "address1") {
                if (this.nrgFlag) {
                    this.valid_message.address1 = "";
                    this.valid.address1 = false;
                } else {
                    this.valid_message.address1 = this.$t("error.validation.required.address");
                    this.valid.address1 = true;
                }
            } else if (targetId === "password") {
                this.valid_message.password = this.$t(
                    "error.validation.required.password"
                );
                this.valid.password = true;
            } else if (targetId === "rePassword") {
                this.valid_message.rePassword = this.$t(
                    "error.validation.required.rePassword"
                );
                this.valid.rePassword = true;
            // 任意入力項目
            } else if (targetId === "address2") {
                this.valid_message.address2 = "";
                this.valid.address2 = false;
            } else if (targetId === "mobile_number") {
                this.valid_message.mobile_number = "";
                this.valid.mobile_number = false;
            }
        },
        /** ----------------------------------------------
         * バリデーション制御
         * ---------------------------------------------- */
        alertCheck: function() {
            if (
                this.familyName !== "" &&
                this.givenName !== "" &&
                this.familyNameKana !== "" &&
                this.givenNameKana !== "" &&
                this.password !== "" &&
                this.rePassword &&
                this.termsOfServices === true
            ) {
                // 南幌以外の入力チェック
                if (!this.nrgFlag &&
                     this.zipCode !== "" &&
                     this.address1 !== ""
                ) {
                    this.alert_clear = false;
                    return;
                }

                if (
                    this.valid.familyName === false &&
                    this.valid.givenName === false &&
                    this.valid.familyNameKana === false &&
                    this.valid.givenNameKana === false &&
                    this.valid.mobile_number === false &&
                    this.valid.zipcode === false &&
                    this.valid.address1 === false &&
                    this.valid.address2 === false &&
                    this.valid.password === false &&
                    this.valid.rePassword === false &&
                    this.recaptcha.setflag
                ) {
                    this.alert_clear = true;
                    this.submit_valid = false;
                } else {
                    this.alert_clear = false;
                }
            } else {
                this.alert_clear = false;
            }
        },
        /** ----------------------------------------------
         * 登録内容確認ボタン 押下時処理
         * ---------------------------------------------- */
        submitConfirmation: function() {
            // 入力チェック
            let check = false;
            if (
                this.familyName !== "" &&
                this.givenName !== "" &&
                this.familyNameKana !== "" &&
                this.givenNameKana !== "" &&
                this.password !== "" &&
                this.rePassword &&
                this.termsOfServices === true &&
                this.valid.familyName === false &&
                this.valid.givenName === false &&
                this.valid.familyNameKana === false &&
                this.valid.givenNameKana === false &&
                this.valid.mobile_number === false &&
                this.valid.zipcode === false &&
                this.valid.address1 === false &&
                this.valid.address2 === false &&
                this.valid.password === false &&
                this.valid.rePassword === false &&
                this.recaptcha.setflag
            ) {
                // 南幌以外の入力チェック
                if (this.nrgFlag) {
                    check = true;
                } else {
                    if (this.zipCode !== "" && this.address1 !== "") {
                        check = true;
                    }
                }
            }

            if (!check) {
                // 初期表示で確認ボタンをクリックした場合のエラーメッセージ追加
                if (this.familyName === '') {
                    this.valid_message.familyName = this.$t("error.validation.required.familyName");
                    this.valid.familyName = true;
                }
                if (this.givenName === '') {
                    this.valid_message.givenName = this.$t("error.validation.required.givenName");
                    this.valid.givenName = true;
                }
                if (this.familyNameKana === '') {
                    this.valid_message.familyNameKana = this.$t("error.validation.required.familyNameKana");
                    this.valid.familyNameKana = true;
                }
                if (this.givenNameKana === '') {
                    this.valid_message.givenNameKana = this.$t("error.validation.required.givenNameKana");
                    this.valid.givenNameKana = true;
                }
                if (this.zipCode === '') {
                    if (!this.nrgFlag) {
                        this.valid_message.zipcode = this.$t("error.validation.required.zipcode");
                        this.valid.zipcode = true;
                    }
                }
                if (this.address1 === '') {
                    if (!this.nrgFlag) {
                        this.valid_message.address1 = this.$t("error.validation.required.address");
                        this.valid.address1 = true;
                    }
                }
                if (this.password === '') {
                    this.valid_message.password = this.$t("error.validation.required.password");
                    this.valid.password = true;
                }
                if (this.rePassword === '') {
                    this.valid_message.rePassword = this.$t("error.validation.required.rePassword");
                    this.valid.rePassword = true;
                }
                if (this.termsOfServices === null) {
                    this.valid_message.termsOfServices = this.$t("error.validation.termsOfServices");
                    this.valid.termsOfServices = true;
                }
                window.scrollTo(0,0);
                this.submit_valid = true;
                this.alert_clear = false;
            } else {
                this.submit_valid = false;
                this.alert_clear = true;
                const urlToken = this.urlToken;
                const birthDate = this.daysJoin(this.year, this.month, this.day);
                if (this.gender === 0) {
                    this.gender_label = "男性";
                } else if (this.gender === 1) {
                    this.gender_label = "女性";
                }
                if (this.mobile_number === null ||
                    this.mobile_number === '') {
                    this.mobile_number_label = '未入力';
                } else {
                    this.mobile_number_label = this.mobile_number;
                }
                this.put_data = {
                    family_name: this.familyName,
                    given_name: this.givenName,
                    family_name_kana: this.hankanaChangeZenkana(this.familyNameKana),
                    given_name_kana: this.hankanaChangeZenkana(this.givenNameKana),
                    zipcode: this.zipCode,
                    address1: this.address1,
                    address2: this.address2,
                    birth_date: birthDate,
                    mobile_number: this.mobile_number,
                    gender: this.gender,
                    token: urlToken,
                    password: this.password,
                    password_confirmation: this.rePassword
                };
                this.input_area = false;
                this.confirmation_area = true;
                window.scrollTo(0,0);
            }
        },

        /** ----------------------------------------------
         * 修正ボタン 押下時処理
         * ---------------------------------------------- */
        submitCancel: function() {
            this.input_area = true;
            this.confirmation_area = false;
            this.alert_clear = false;
            this.recaptcha.setflag = false;
        },

        /** ----------------------------------------------
         * 登録ボタン 押下時処理
         * ---------------------------------------------- */
        submitSingUp: async function() {
            this.$store.commit("loading/setIsLoading", true);
            if (this.$route.query.state) {
                this.auth_code = this.$route.query.state;
            } else if (this.$route.query.token){
                this.auth_code = this.$route.query.token;
            } else {
                this.auth_code = false;
            }
            await this.$apollo
                .mutate({
                    mutation: REGISTER_MEMBER,
                    variables: {
                        family_name: this.put_data.family_name,
                        given_name: this.put_data.given_name,
                        family_name_kana: this.put_data.family_name_kana,
                        given_name_kana: this.put_data.given_name_kana,
                        zipcode: this.put_data.zipcode,
                        address1: this.put_data.address1,
                        address2: this.put_data.address2,
                        birth_date: this.put_data.birth_date,
                        mobile_number: this.put_data.mobile_number,
                        gender: this.put_data.gender,
                        token: this.put_data.token,
                        password: this.put_data.password,
                        password_confirmation: this.put_data.password_confirmation,
                        golf_group_code: process.env.MIX_GROUP_CODE,
                        auth_code: this.auth_code
                    }
                })
                .then(res => {
                    this.$router.push({ path: "/signup-complete" });
                })
                .catch(error => {
                    if (
                        error.graphQLErrors[0].message ==
                        "Internal server error"
                    ) {
                        this.expiration = this.$t(
                            "error.validation.systemError"
                        );
                    } else {
                        this.expiration = error.graphQLErrors[0].message;
                    }
                    this.confirmation_area = false;
                    this.error_page = true;
                    this.$store.commit("loading/setIsLoading", false);
                });
        },
        /** ----------------------------------------------
         * 画像認証関連
         * ---------------------------------------------- */
        onVerify(response) {
            // レスポンスのトークンをセット
            this.recaptcha.responce = response;
            //値がセットされればフラグセット
            if (
                this.recaptcha.responce !== null &&
                this.recaptcha.responce !== undefined &&
                this.recaptcha.responce.length > 0
            ) {
                this.recaptcha.setflag = true;
                this.alertCheck();
            }
        },
        onExpired() {
            //レスポンスのトークンを空に戻す
            this.recaptcha.responce = "";
            //フラグを下す
            this.recaptcha.setflag = false;
            this.alertCheck();
        },
        formatSP(data){
            if (!isNaN(data)){
                if (data.length == 11) {
                    return data.substr(0,3) + "-" + data.substr(3,4) + "-" + data.substr(7,4);
                }
            }
            return data
        },
        /** --------------------------------------------
         * ハイフン無しの郵便番号を012-3456形式に変換する
         * @param zipCode 対象の郵便番号
         * -------------------------------------------- */
        zipCodeFormat: function (zipCpde) {
            if (!zipCpde) {
                return '未入力';
            } else if (zipCpde.length == 7) {
                var before = zipCpde.substring( 0, 3 );
                var after = zipCpde.substring( 3, 7 );
                return before + '-' + after;
            } else {
                return zipCpde;
            }
        },
        /** --------------------------------------------
         * 住所が未入力の場合のテキストを設定
         * @param address 住所
         * -------------------------------------------- */
        addressFormat: function (address) {
            if (!address) {
                return '未入力';
            } else {
                return address;
            }
        },
        /** ----------------------------------------------
         * パスワード入力フォーム自動補完制御
         * -------------------------------------------- */
        passwordForm (event) {
            if (event.type === 'mouseover') {
                if (event.target.id === 'password') {
                    var passwordForm = document.getElementById('password');
                    passwordForm.removeAttribute("readonly");
                } else if (event.target.id === 'rePassword') {
                    var rePasswordForm = document.getElementById('rePassword');
                    rePasswordForm.removeAttribute("readonly");
                }
            } else {
                if (event.target.id === 'password') {
                    var passwordForm = document.getElementById('password');
                    passwordForm.setAttribute("readonly", "readonly");
                } else if (event.target.id === 'rePassword') {
                    var rePasswordForm = document.getElementById('rePassword');
                    rePasswordForm.setAttribute("readonly", "readonly");
                }
            }
        }
    }
};
</script>

<style scoped>
.container {
    padding-right: 0;
    padding-left: 0;
}
.signup-container {
    padding-right: 15px;
    padding-left: 15px;
    padding-bottom: 15px;
}
.signup-confirm-container {
    height: 100vh;
    padding-right: 15px;
    padding-left: 15px;
    padding-bottom: 15px;
}
.ruleArea {
    padding: 5px;
}
.icon_error {
    transform: scale(0.8);
    background-size: 40px;
    height: 40px;
    width: 40px;
    float: left;
    margin: 5px;
}
.alert-text {
    text-decoration: underline;
}
.signUpContents {
    padding-top: 50px;
}
.passwordReadOnly {
    background-color: #ffffff;
}
@media (max-width: 575px) {
    .signup-container{
        background-color: initial;
    }
    .signup-confirm-container{
        background-color: initial;
    }
}
</style>
